import type { UseControllerProps } from "react-hook-form";

import ResizeTextarea from "react-textarea-autosize";
import { useController, useFormContext, useWatch } from "react-hook-form";
import { ChangeEvent, useEffect, useState } from "react";
import { useDebounce } from "react-use";

interface TextActionOptionalProps {
	name: UseControllerProps<ObservationFormState>["name"];

	questionNumber: number;

	staticInput?: boolean;
}

const TextActionOptional = ({
	name,
	questionNumber,
	staticInput
}: TextActionOptionalProps) => {
	const { control, setValue } = useFormContext<ObservationFormState>();

	const {
		field: { value }
	} = useController({
		control,
		name
	});

	const [savedValue, setSavedValue] = useState<string>(value);

	useEffect(() => {
		// We want to include "" values
		// Setting a null value makes the input editable even though it shouldn't
		if (value !== null || value !== undefined) setSavedValue(value);
	}, [value]);

	const handleChange = (event: ChangeEvent<HTMLTextAreaElement>) => {
		if (staticInput) return;

		setSavedValue(event.target.value);
	};

	const { isDisabled } = useWatch({
		control
	});

	useDebounce(
		() => {
			setValue(name, savedValue);
		},
		1000,
		[savedValue]
	);

	return (
		<div className="mt-8">
			<p className="font-heading text-lg font-medium">Actions (optional)</p>

			<ResizeTextarea
				id={`question-${questionNumber}`}
				placeholder="Please enter comments to your answer"
				className="w-full mt-4 px-3 py-2 bg-white border border-border rounded-md text-base resize-none overflow-hidden focus:outline-none focus:ring-2 focus:ring-ring disabled:opacity-50 disabled:cursor-not-allowed"
				disabled={isDisabled}
				value={savedValue}
				onChange={handleChange}
			/>
		</div>
	);
};

export { TextActionOptional, type TextActionOptionalProps };
